import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  getItemIdFromArgsConfig,
  redirectUrlArgsConfig,
  retainUrlParamsArgsConfig,
} from '../../utils/event_constants';

export const boxActions = [
  {
    name: 'initiateBoxAuth',
    label: 'Initiate Box Auth',
    args: [...redirectUrlArgsConfig, retainUrlParamsArgsConfig, ...alertMessagesArgsConfig],
  },
  {
    name: 'uploadFileToBox',
    label: 'Upload Files To Box',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fileField', label: 'Select File Field' }),
      collectionFieldArgsConfig({ name: 'folderField', label: 'Select Folder Path Field' }),
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
];
